import getEqualArrayItems from "./on-property-percents/get-equal-array-items";

/**
 *
 * @param {TemporaryDataProps} data
 * @param {StepProps | TimelineMapProps} step
 * @param {Number} number  Step number
 */
const onCoordinatesStepStatus = (data, step, number) => {
  const timeline = /** @type {TimelineMapProps} */ (data.get("timeline"));
  const last = /** @type {Array<Number>} */ (step.get("last-progress-array"));
  const statuses = /** @type {Array<Number>} */ (timeline.get("statuses"));

  if (last.length > 2) {
    statuses[number] = getEqualArrayItems(last) ? 1 : -1;
  }
};

export default onCoordinatesStepStatus;
